// extracted by mini-css-extract-plugin
export default {"top_selling_container":"top_selling_products_top_selling_container__TClzQ","top_selling_title":"top_selling_products_top_selling_title__glGSN"};